module.exports = require('./ui/overlays/load-rom.template');